import React, { Component } from 'react';
import { notification, Input, Button, Form } from 'antd';
import { gql } from '@apollo/client';

const UPDATE_NICKNAME = gql`
  mutation UserUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        uuid
        nickname
      }
    }
  }
`;

class UpdateNicknameForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }

  onFinish = async (values) => {
    const { client } = this.props;

    this.setState({
      loading: true,
    });

    const { nickname } = values;

    await client.mutate({
      mutation: UPDATE_NICKNAME,
      variables: {
        input: {
          nickname,
        },
      },
    });

    notification.success({
      message: 'Account nickname updated',
    });

    this.setState({
      loading: false,
    });
  };

  render() {
    const { currentUser } = this.props;
    const { loading } = this.state;

    return (
      <Form onFinish={this.onFinish} initialValues={{ nickname: currentUser.nickname }}>
        <Form.Item
          name="nickname"
          rules={[{ required: true, message: 'Please enter a name' }]}
        >
          <Input
            data-aaa="accountNickname"
            autoComplete="given-name"
            prefix={<i className="fal fa-heart" />}
            placeholder="Nickname"
          />
        </Form.Item>
        <Form.Item>
          <Button
            data-aaa="updateNicknameSubmit"
            type="primary"
            htmlType="submit"
            block
            loading={loading}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default UpdateNicknameForm;
